// Mobilités urbaines — EDPM (trottinettes, monoroues, gyropodes) + VAE (vélos à assistance électrique)
// + partage de la route. Contenu de sensibilisation et réglementation 2026.

export const edpm = {
  id: 'edpm',
  icon: 'Bike',
  color: '#f59e0b',
  soft: '#fff7ed',
  tagline: 'Trottinettes, monoroues, gyropodes électriques.',
  label: 'EDPM — Engin de Déplacement Personnel Motorisé',
  description:
    "Les trottinettes électriques, monoroues et gyropodes sont appelés EDPM. Ils partagent la route comme les vélos, mais avec des règles strictes — et une vulnérabilité équivalente à celle des motards.",
  reglementation: [
    { label: 'Âge minimum', value: '14 ans', detail: 'Conduite interdite avant 14 ans, même sur trottoir.' },
    { label: 'Vitesse maximale', value: '25 km/h', detail: 'Bridage obligatoire — au-delà = scooter électrique soumis au permis AM.' },
    { label: 'Circulation', value: 'Pistes cyclables / voirie', detail: "Trottoirs interdits (sauf cas spécifique avec moteur coupé). Zones 30 autorisées. Voies > 50 km/h interdites hors pistes dédiées." },
    { label: 'Passagers', value: 'Interdit', detail: 'Un seul utilisateur par EDPM, jamais à deux.' },
    { label: 'Téléphone & écouteurs', value: 'Interdits', detail: 'Comme pour les autres véhicules.' }
  ],
  equipement: [
    { obligatoire: true, label: 'Feux AV/AR', detail: 'Allumés de nuit et par mauvaise visibilité.' },
    { obligatoire: true, label: 'Avertisseur sonore', detail: 'Sonnette ou klaxon obligatoire.' },
    { obligatoire: true, label: 'Système de freinage', detail: 'Freins en état de marche (les EDPM sans frein sont illégaux).' },
    { obligatoire: true, label: 'Dispositifs réfléchissants', detail: 'Visibles latéralement et à l\'arrière.' },
    { obligatoire: false, label: 'Casque', detail: 'Fortement recommandé (obligatoire hors agglomération).' },
    { obligatoire: false, label: 'Gilet rétro-réfléchissant', detail: 'Obligatoire la nuit hors agglomération.' },
    { obligatoire: false, label: 'Gants & blouson renforcés', detail: 'Recommandés — les blessures EDPM ressemblent aux blessures moto.' }
  ],
  risques: [
    'Chute en solo (bosse, trou, freinage brutal) = fracture poignet/coude fréquente.',
    'Collision avec voiture à basse vitesse = blessures crâniennes, même à 25 km/h.',
    'Pluie + rails tramway = glissades typiques.',
    'Invisibilité nocturne sans éclairage adéquat.'
  ],
  bonnesPratiques: [
    'Rouler à droite, comme un vélo.',
    'Signaler ses changements de direction au bras.',
    'Anticiper les ouvertures de portières.',
    'Descendre et pousser sur les trottoirs piétons.'
  ]
};

export const vae = {
  id: 'vae',
  icon: 'Bike',
  color: '#18794e',
  soft: '#eaf8ef',
  tagline: 'Vélos à Assistance Électrique (VAE).',
  label: 'VAE — Vélo à Assistance Électrique',
  description:
    "Le VAE est un vélo normal doté d'un moteur d'assistance qui s'active uniquement au pédalage. Il relève du Code de la route comme un vélo classique, à condition de respecter les limites.",
  reglementation: [
    { label: 'Puissance max', value: '250 W', detail: 'Au-delà = cyclomoteur et besoin du permis AM.' },
    { label: 'Vitesse max assistée', value: '25 km/h', detail: 'L\'assistance doit se couper à 25 km/h (pédalage possible au-delà, sans moteur).' },
    { label: 'Pédalage obligatoire', value: 'Oui', detail: 'L\'assistance s\'active uniquement si tu pédales (sinon c\'est un cyclomoteur).' },
    { label: 'Âge minimum', value: 'Aucun', detail: 'Accessible à tous. Le Casque est obligatoire pour les enfants de moins de 12 ans.' },
    { label: 'Circulation', value: 'Vélo', detail: 'Pistes cyclables, voirie. Même règles qu\'un vélo classique.' }
  ],
  equipement: [
    { obligatoire: true, label: 'Feux AV/AR', detail: 'Jaune/blanc à l\'avant, rouge à l\'arrière, allumés de nuit.' },
    { obligatoire: true, label: 'Sonnette', detail: 'Audible à 50 m minimum.' },
    { obligatoire: true, label: 'Freins sur les 2 roues', detail: 'Fonctionnels.' },
    { obligatoire: true, label: 'Catadioptres', detail: 'Roues + pédales + arrière + avant.' },
    { obligatoire: false, label: 'Casque (moins de 12 ans)', detail: 'Obligatoire pour tout enfant transporté ou cycliste < 12 ans.' },
    { obligatoire: false, label: 'Casque (adulte)', detail: 'Recommandé — réduit de 85 % le risque de traumatisme crânien.' },
    { obligatoire: false, label: 'Gilet rétro-réfléchissant', detail: 'Obligatoire la nuit hors agglomération.' }
  ],
  risques: [
    'Vitesse d\'assistance (25 km/h) sans protection → chutes plus graves qu\'en vélo classique.',
    'Mauvaise gestion du poids (VAE = 20-25 kg) en virage ou freinage.',
    'Usagers novices qui surestiment leurs capacités grâce au moteur.',
    'Autonomie de batterie mal estimée = vélo lourd à pousser en panne.'
  ],
  bonnesPratiques: [
    'Freinage progressif (le poids du VAE augmente les distances).',
    'Respecter les 25 km/h en descente : le moteur se coupe, mais le poids continue.',
    'Utiliser les pistes cyclables dès que possible.',
    'Contrôler régulièrement freins, éclairage et pression des pneus.'
  ]
};

export const assurancesMobilites = {
  edpm: {
    obligatoire: [
      'Responsabilité Civile (RC) obligatoire depuis 2019 pour tout EDPM (Code des assurances, art. L211-1).',
      'Sans assurance : amende forfaitaire 500 € (jusqu\'à 3 750 € en récidive ou audience), immobilisation et responsabilité civile personnelle en cas d\'accident — Code de la route, art. L324-2.'
    ],
    conseillee: [
      'Garantie vol (cible fréquente en ville).',
      'Garantie dommages matériels (casse, tags, chute).',
      'Garantie conducteur (blessures corporelles du conducteur).',
      'Protection juridique.'
    ],
    coutAnnuel: 'Environ 60 à 200 €/an.',
    note: 'Beaucoup d\'assurances habitation couvrent la RC vie privée — vérifie si elle inclut les EDPM.'
  },
  vae: {
    obligatoire: [
      'Aucune assurance obligatoire au titre du VAE lui-même (relève du vélo).',
      'Attention : si VAE > 250 W ou vitesse > 25 km/h → devient cyclomoteur → RC obligatoire (Code des assurances, art. L211-1).'
    ],
    conseillee: [
      'Garantie vol (VAE = cibles premium, 800 à 5000 € en valeur).',
      'Garantie bris de batterie ou moteur.',
      'Garantie conducteur (blessures).',
      'Casque & équipement assurés.'
    ],
    coutAnnuel: 'Environ 50 à 180 €/an (souvent inclus dans multirisques habitation).',
    note: 'Sans RC personnelle, tu es couvert par l\'assurance habitation si elle inclut la « vie privée ».'
  }
};

export const partageRoute = [
  {
    icon: 'Eye',
    title: 'Se rendre visible',
    desc: 'Feux, gilet rétro-réfléchissant, placement — même de jour, le regard des autres usagers est sollicité par les voitures en priorité.',
    tip: 'Quand tu doutes d\'être vu, suppose que tu ne l\'es pas.'
  },
  {
    icon: 'Route',
    title: 'Trouver sa place',
    desc: 'Pistes cyclables dès que possible. En voirie partagée, rester à droite et anticiper les obstacles (portières, piétons, bus).',
    tip: 'Laisse 1 mètre minimum entre toi et les voitures stationnées.'
  },
  {
    icon: 'Users',
    title: 'Partager, pas dominer',
    desc: 'Les trottoirs sont aux piétons. Les pistes cyclables sont partagées entre vélos et EDPM — politesse, sonnette à 10 m.',
    tip: 'Dépasse toujours à gauche, jamais à droite.'
  },
  {
    icon: 'ShieldAlert',
    title: 'Respecter la vulnérabilité',
    desc: 'Piétons > vélos > EDPM > voitures : la hiérarchie est basée sur la vulnérabilité, pas sur la vitesse.',
    tip: 'Même prioritaire, je ralentis devant un piéton, un enfant, un chien.'
  },
  {
    icon: 'Gauge',
    title: 'Adapter sa vitesse',
    desc: '25 km/h en EDPM ou VAE = identique à une moto en ville. Même impact = même précautions.',
    tip: 'Pluie, nuit, trafic = réduire. Toujours.'
  },
  {
    icon: 'PhoneOff',
    title: 'Rester focus',
    desc: 'Téléphone et écouteurs interdits au guidon, comme en voiture ou à moto. Ton attention = ta sécurité.',
    tip: 'Bluetooth solo à volume faible OK. Oreillettes = 135 € d\'amende et 3 points retirés (Code de la route, art. R412-6-1).'
  }
];
